




















































import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  // IdentityInfo,
  CreateMode,
  CreativeConfig,
} from '@tt4b/ttam-enums';
import { computed, defineComponent, onMounted, PropType, ref, toRefs, watch } from '@vue/composition-api';
import {
  useStdAdgroupIs,
  useAdgroupMode,
  useShowcaseIdentityListApi,
  useAdgroupCommonAlertInfo,
} from '@tt4b/ttam-hooks';
import { i18n } from '@tt4b/ttam-i18n';
import { CreateIdentityFormData, IdentityItem } from './../../identity/types';
import IdentityList from '@/components/identity/common/list.vue';
import OperationList from '@/components/common/operation-list/index.vue';
import SelectNoDataIcon from '@tt4b/ttam-assets/src/svgs/select-no-data.svg';

import { useShowcaseArea, useShowcaseIdentityListDataSource, useRules } from './hooks';

const name = 'ttam-product-source-showcase-compose';

export default defineComponent({
  name,
  components: {
    OperationList,
    SelectNoDataIcon,
    IdentityList,
    // TtamIdentityTiktokAccountPopover: Identity.TtamIdentityTiktokAccountPopover,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    creativeMode: {
      type: Boolean,
      default: false,
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    isShowLabel: {
      type: Boolean,
      default: true,
    },
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const keyword = ref('');
    const identityRef = ref(null);
    const { adgroupData, creativeMode, campaignData, createMode, creativeConfig } = toRefs(props);

    const { getShowcaseArea } = useShowcaseArea();

    // status get
    const { isLiveAds, isStandardAdsWithShowcase, isProductSales } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const identityInfoData = ref({
      avatarIcon: {
        width: 20,
        height: 20,
        webUri: '',
        url: '',
      },
      displayName: '',
      identityId: '',
    });
    const { isEdit } = useAdgroupMode({ createMode });

    // form rules
    const { showcaseValidator } = useRules();

    // form value: identity id
    const curIdentityData = computed(() => ({
      identityId: adgroupData.value?.identityId,
      identityType: adgroupData.value?.identityType,
    }));

    // live 且 creative 层级下 TikTok Identity 只可查看
    const disabledTTIdentity = computed(
      () => (creativeMode.value && isLiveAds.value) || isEdit.value || creativeConfig.value.disableIdentity,
    );
    // TikTok identity list get
    const {
      dataSource: TikTokIdentityList,
      originalData: originTikTokIdentityList,
      isEmpty: isTikTokIdentityEmpty,
      isLoading: isTikTokIdentityLoading,
      run: getTikTokIdentityList,
      hasLoaded: isTikTokIdentityListReady,
    } = useShowcaseIdentityListDataSource({
      adgroupData,
      campaignData,
    });
    const { addAdgroupAlertInfo } = useAdgroupCommonAlertInfo();
    // VSA下没有showcase权限，要重新获取identity-name展示
    const noAccessShowcaseOfVsaType = computed(() =>
      Boolean(
        isProductSales &&
          isStandardAdsWithShowcase.value &&
          isEdit.value &&
          isTikTokIdentityListReady.value &&
          disabledTTIdentity.value &&
          TikTokIdentityList.value &&
          !TikTokIdentityList.value?.find?.(i => i.id === curIdentityData.value.identityId),
      ),
    );
    const isInitLoading = computed(() => !identityRef.value?.popperVisible && isTikTokIdentityLoading.value);

    const onTikTokIdentityChange = (data: IdentityItem) => {
      const curIdentity = originTikTokIdentityList.value?.find(i => i.identityId === data.id);
      emit('identity-change', {
        identityData: curIdentity,
        identityId: curIdentity?.identityId,
        identityTtsShopId: curIdentity?.identityTtsShopId,
      });
      emit('input', curIdentity?.identityId);
      // 更新地域数据
      curIdentity && getShowcaseArea(curIdentity);
    };

    onMounted(() => {
      if (curIdentityData.value.identityId) {
        getShowcaseArea(curIdentityData.value);
      }
    });

    const onRefresh = async () => {
      await getTikTokIdentityList();
      emit('after-refresh', originTikTokIdentityList.value);
    };

    const onKeywordInput = (val: string) => {
      keyword.value = val;
    };

    const operationList = computed(() => [
      {
        icon: 'vi-icon2-refresh',
        click: () => {
          onRefresh();
          identityRef.value?.onFocus();
        },
        disabled: disabledTTIdentity.value,
        hint: i18n.t('adgroup_convert-refresh'),
        trackProps: {
          'data-tea-click': 'module_ad_group_refresh_shop_catalog_click',
          'data-tea-expose': 'module_ad_group_refresh_shop_catalog_impression',
          'data-tea-source': 'showcase',
        },
      },
    ]);
    watch(
      noAccessShowcaseOfVsaType,
      async val => {
        if (val) {
          try {
            let { identityList = [] } = await useShowcaseIdentityListApi();
            identityList?.forEach?.(item => {
              item.displayName = i18n.t('module_creative_showcase_identity_name', {
                identity: item.displayName,
              }) as string;
            });
            let identityInfo = identityList?.find?.(i => i.identityId === curIdentityData.value.identityId);

            if (identityInfo?.identityId) {
              identityInfoData.value.displayName = identityInfo.displayName;
              identityInfoData.value.avatarIcon = identityInfo.avatarIcon as any;
              identityInfoData.value.identityId = identityInfo.identityId;
            }
            // canUseShowcase为false,没有show case 权限 显示alert
            if (identityInfo?.canUseShowcase === false) {
              addAdgroupAlertInfo({
                text: i18n.t('module_ad_no_permission_showcase_edit_banner_text'),
                type: 'error',
                show: true,
                key: 'module_ad_no_permission_showcase_edit_banner_text',
              });
            }
          } catch (error) {}
        }
      },
      {
        immediate: true,
      },
    );
    // 没有权限的也要回显
    const showNoAccessIdentityInfo = computed(() =>
      Boolean(noAccessShowcaseOfVsaType.value && identityInfoData.value.identityId),
    );
    return {
      name,
      isEdit,
      isInitLoading,
      identityRef,
      curIdentityData,
      showcaseValidator,
      disabledTTIdentity,
      TikTokIdentityList,
      isTikTokIdentityEmpty,
      isTikTokIdentityLoading,
      operationList,
      onKeywordInput,
      onRefresh,
      onTikTokIdentityChange,
      identityInfoData,
      showNoAccessIdentityInfo,
    };
  },
});
